import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8.33331 4.99967H4.99998C4.07951 4.99967 3.33331 5.74587 3.33331 6.66634V14.9997C3.33331 15.9201 4.07951 16.6663 4.99998 16.6663H13.3333C14.2538 16.6663 15 15.9201 15 14.9997V11.6663M11.6666 3.33301H16.6666M16.6666 3.33301V8.33301M16.6666 3.33301L8.33331 11.6663" />
  </svg>
);
